/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import PropTypes from 'prop-types';

// Cabeçalho padrão de tela de admin: título grande + descrição curta que
// explica o que o usuário faz aqui + slot pra ação primária (ex: "Novo X").
// Usar em toda página de listagem pra manter consistência visual.
export default function PageHeader({ title, description, action }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
        spacing={2}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: '#2a2a2a', mb: 0.5 }}
          >
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" sx={{ color: '#666', maxWidth: 720 }}>
              {description}
            </Typography>
          ) : null}
        </Box>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Stack>
    </Box>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node,
};
